// Keep currentPhysicsRevision aligned with backend/internal/game.PhysicsRevision.
export const currentPhysicsRevision = 10;
export type PhysicsRevision = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10;
export const physicsProtocol = `scrapline-physics-${currentPhysicsRevision}`;
// Revision-2 APIs read only the first query value. Advertise their retained
// policy first; newer APIs check the complete list before granting a seat.
export const physicsQuery = `physics=2&physics=3&physics=4&physics=5&physics=6&physics=7&physics=8&physics=9&physics=${currentPhysicsRevision}`;
export const physicsProtocols = [physicsProtocol, 'scrapline-physics-9', 'scrapline-physics-8', 'scrapline-physics-7', 'scrapline-physics-6', 'scrapline-physics-5', 'scrapline-physics-4', 'scrapline-physics-3', 'scrapline-physics-2'];
export const gameUpdateCode = 'game_update_required';
export const gameUpdateMessage = 'SCRAPLINE has updated. Reload before boarding so your movement stays in sync.';

/** Missing revisions identify the API deployed before capability negotiation. */
export function physicsRevision(value: unknown): PhysicsRevision | null {
  if (value === undefined || value === 1) return 1;
  if (value === 2) return 2;
  if (value === 3) return 3;
  if (value === 4) return 4;
  if (value === 5) return 5;
  if (value === 6) return 6;
  if (value === 7) return 7;
  if (value === 8) return 8;
  if (value === 9) return 9;
  return value === currentPhysicsRevision ? currentPhysicsRevision : null;
}
